export const ErrorMessage = {
    ErrorOccured: 'message_some_error_occured',
    Unauthorized: "Unauthorized",
    UnauthorizedAccess: "unauthorized_access",
    TokenExpired: 'TokenExpired',
    NameAlreadyExists: 'NameAlreadyExists',
    InvalidUsernameOrPassword: "InvalidEmailOrPassword",
    IdNotFound: "IdNotFound",
    EmailAlreadyExists: "EmailAlreadyExists",
    UserTypeChanged: "UserTypeChanged",
    EmailChanged: "EmailChanged",
    Forbidden: "Forbidden",
    NoMissingTicketsFound: "NoMissingTicketsFound",
    RefreshTokenExpired: 'RefreshTokenExpired',
    RefreshTokenNotInDatabase: 'RefreshTokenNotInDatabase',
    ErrorLog: 'ErrorLog',
    AllRecordsDuplicate: 'AllRecordsDuplicate',
    SomeRecordsDuplicate: 'SomeRecordsDuplicate',
    LowerConsumptionLimit: 'LowerConsumptionLimitException',
    AllocationVolumeException: 'AllocationVolumeException',
    InvalidAssetAllocation: 'InvalidAssetAllocation',
    SomeRecordsInvalidAssetAllocation: 'SomeRecordsInvalidAssetAllocation',
}
export const RestMethodConstants = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete'
}
